// ============================================
// NETWORK CONFIG
// Switch between mainnet & testnet HERE ONLY.
// The user side never sees "testnet" wording.
// ============================================

// >>> CHOOSE ACTIVE NETWORK <<<
// 'mainnet' | 'testnet'
export const ACTIVE_NETWORK = 'testnet';

export const NETWORKS = {
  mainnet: {
    key: 'mainnet',
    chainId: 56,
    chainIdHex: '0x38',
    name: 'BNB Smart Chain',
    displayName: 'BNB Chain',
    rpcUrls: [
      'https://bsc-dataseed.binance.org/',
      'https://bsc-dataseed1.defibit.io/',
      'https://bsc-dataseed1.ninicoin.io/',
    ],
    blockExplorer: 'https://bscscan.com',
    nativeCurrency: {
      name: 'BNB',
      symbol: 'BNB',
      decimals: 18,
    },
  },
  testnet: {
    key: 'testnet',
    chainId: 97,
    chainIdHex: '0x61',
    name: 'BNB Smart Chain',
    displayName: 'BNB Chain',
    rpcUrls: [
      'https://data-seed-prebsc-1-s1.binance.org:8545/',
      'https://data-seed-prebsc-2-s1.binance.org:8545/',
    ],
    blockExplorer: 'https://testnet.bscscan.com',
    nativeCurrency: {
      name: 'BNB',
      symbol: 'BNB',
      decimals: 18,
    },
  },
};

export const CURRENT_NETWORK = NETWORKS[ACTIVE_NETWORK];
